module.exports = __webpack_public_path__ + "img/downhill_line1.fbebb58e.svg";